<template>
  <v-navigation-drawer
      app
      clipped
      left
      v-model="drawer"
      :color="variables.colorPrimaryDarken"
      class="aside ps-3"
      dark
      :width="280"
      :mobile-breakpoint="1400"
      :mini-variant.sync="mini"
    >

      <v-container class="d-flex justify-space-between align-center aside-header">
        <v-toolbar-title
          class="logo-aside w-100"
          @click="$router.push( { name: 'home'} )"
        >
          <div class="logo-row">
            <img :src="brand.logo" alt="Logo" class="logo" />
          </div>

          <div class="aside-menu-mobile">
            <v-list flat>
              <v-list-item-group class="aside-menu-list-group aside-menu-list-group--usuario" color="#FFF">
                <v-list-item class="aside-menu-list-group--usuario-item">
                  <v-list-item-icon style="margin-right: 10px;">
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title class="aside-menu-list-group--usuario-titulo">{{ user.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ user.role }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>

          <div class="pr-5 aside-balances">
            <div class="contrato pa-2 mt-3" v-if="contracts">
              <v-icon size="16" class="chip-icon">mdi-cash-multiple</v-icon>
              <span> {{ contracts }} </span>
            </div>

            <div class="saldo d-flex align-center py-2 ps-2 mt-3">
              <v-icon size="16" class="chip-icon">mdi-wallet-outline</v-icon>
              <v-skeleton-loader
                :loading="loadingBalance"
                :transition="'fade-transition'"
                type="text"
                width="100"
                height="20"
              >
                <span>{{ saldo | currency }}</span>
              </v-skeleton-loader>
            </div>
          </div>

        </v-toolbar-title>
      </v-container>

      <v-divider class="aside-divider" />

      <div :dense="true">
        <BrMenuItem :route="listaMenuOrdenado" @logout="logout" />
      </div>

      <template v-slot:append>
        <div class="aside-footer">
          <span class="version">v{{ appVersion }}</span>
        </div>
      </template>
  </v-navigation-drawer>
</template>

<script>
import Events from '@/core/service/events'
import { mapActions, mapGetters} from 'vuex'
import storage from '@/core/service/localStorage'
import variables from '@/assets/styles/helpers/_variables.scss'
import BrMenuItem from './components/menu-item'
import { errorSnackbar } from '@/core/service/utils'
import { flattenDeep } from 'lodash'
import brand from '@/core/brand'

export default {
  name: 'BrAside',
  components: {
    // BrMenuItem: () => import('./components/menu-item')
    BrMenuItem,
    // buger
  },
  data: () => ({
    drawer: true,
    activeFilter: null,
    states: null,
    mini: false
  }),

  watch: {
    drawer: (val) => {
      Events.$emit('aside::alterDrawer', val)
    }
  },

  mounted () {
    Events.$on('appBar::drawer', () => {
      this.drawer = !this.drawer
    })

    this.getTermos()
    this.getSaldo()
  },

  methods: {
    ...mapActions('auth', ['getUser']),
    ...mapActions('termoConsentimento', ['getTermos']),
    ...mapActions('carteira', ['getSaldoAtual']),
    logout () {
      storage.remove('auth-token')
      storage.remove('jwt')
      this.$router.replace('/auth')
    },

    draw () {
      this.mini = !this.mini
    },

    ordernar (val) {
      let ordered = {}

      Object.keys(val).sort().forEach(function(key) {
        ordered[key] = val[key];
      })
      // console.log(ordered)
      const obj = ordered['afiliados'] 
      return obj ? Object.keys(obj).map(key => obj[key]) : {}
    },

    getSaldo() {
      this.getSaldoAtual()
        .catch(err => { errorSnackbar(err.error) })
    },
  },

  computed: {
    ...mapGetters('users', ['listaMenuTratado']),
    ...mapGetters('auth', ['user']),
    ...mapGetters('termoConsentimento', ['termoAtual']),
    ...mapGetters('carteira', ['creditBalance', 'loadingBalance']),
    variables: () => variables,
    brand: () => brand,
    routes () {
      return this.$router
    },

    listaMenuOrdenado () {
      const teste = flattenDeep(this.ordernar(this.listaMenuTratado))
      const filtrado = teste.filter(item => item.name !== 'pixel')
      return [...filtrado].sort((a, b) => {
        if (a.realName === 'Dashboard') return -1
        if (b.realName === 'Dashboard') return 1
        return 0
      })
    },

    appVersion () {
      return process.env.VUE_APP_VERSION
    },

    contracts () {
      if (this.user.contracts) return this.user.contracts.map(it => it.name).join(', ')
      return ''
    },

    saldo () {
      return this.creditBalance || 0
    }
  }
}
</script>

<style lang="scss" src="@/assets/styles/view/aside.scss"></style>